<div class="row">
  <h3 class="text-center py-3 arb-large-heading">MANAGE TASKS</h3>
</div>
<div class="d-flex justify-content-center border-bottom px-2 text-white">
  <div class="m-2">
    <button
      class="btn btn-light text-uppercase"
      [ngClass]="{ active: activeNavIndex === 0 }"
      (click)="setActiveNav(0)"
      [disabled]="activeNavIndex === 0"
    >
      View Open Tasks
    </button>
  </div>
  <div class="m-2">
    <button
      class="btn btn-light text-uppercase"
      [ngClass]="{ active: activeNavIndex === 1 }"
      (click)="setActiveNav(1)"
      [disabled]="activeNavIndex === 1"
    >
      Create New Task
    </button>
  </div>
  <div class="m-2">
    <button
      class="btn btn-light text-uppercase"
      [ngClass]="{ active: activeNavIndex === 2 }"
      (click)="setActiveNav(2)"
      [disabled]="activeNavIndex === 2"
    >
      View Closed Tasks
    </button>
  </div>
  <div class="m-2 ms-auto">
    <button class="btn btn-cancel text-uppercase" (click)="goToPreviousScreen()">Close</button>
  </div>
</div>
